import Vue from 'vue'
import PopupManager from 'element-ui/lib/utils/popup/popup-manager.js'

Vue.directive('dom-active', {
  update() {},
  bind(el, binding, vnode) {
    // console.log('bind', el, binding, vnode)
  },
  inserted: function (el, binding, vnode) {
    el.querySelector('.el-dialog__header').addEventListener(
      'mousedown',
      (e) => {
        el.style.zIndex = PopupManager.nextZIndex()
      },
    )
  },
  componentUpdated: function (el, binding, vnode) {},
})
